<template>
    <DashboardContainer>
        <textCampaigns/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import textCampaigns from '../components/marketing/textCampaigns'

export default {
    name: 'etemplate',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        textCampaigns
    }
}
</script>